'use client';
import { useState, useCallback } from 'react';

/**
 * Uses a dummy state variable to force a rerender.
 * Useful when a variable's updates cannot be subscribed to.
 *
 * @returns function to force a rerender.
 */
const useForceUpdate = () => {
    const [, updateDummyState] = useState(true);
    return useCallback(() => updateDummyState((prev) => !prev), []);
};

export { useForceUpdate };
//# sourceMappingURL=use-force-update.js.map
